export const FETCH_LIST_ROLES = 'ROLES'

export const RESET_LIST_ROLES = 'RESET'

export const CHANGE_STATUS = 'CHANGE_STATUS'

export const CHANGE_PHONE = 'CHANGE_PHONE'

export const CHANGE_LAYOUT_FILTER = 'CHANGE_LAYOUT_FILTER'

export const CHANGE_LAYOUT_TABLE = 'CHANGE_LAYOUT_TABLE'

export const CHANGE_LOGO_TENANT = 'CHANGE_LOGO_TENANT'

export const UPDATE_SSE_DATA = 'UPDATE_SSE_DATA'

export const UPDATE_SOCKET_DATA = 'UPDATE_SOCKET_DATA'

export const ADD_DIALOG = "ADD_DIALOG"

export const REMOVE_DIALOG = "REMOVE_DIALOG"

export const EDIT_DIALOG = "EDIT_DIALOG"

export const MINIMIZED_DIALOG = "MINIMIZED_DIALOG"

export const GET_AGAIN_DIALOG = "GET_AGAIN_DIALOG"

export const ADD_TAB = "ADD_TAB"

export const ADD_LIST_TAB = "ADD_LIST_TAB"

export const REMOVE_TAB = "REMOVE_TAB"

export const CHANGE_TAB_ACTIVE = "CHANGE_TAB_ACTIVE"

export const PAGINATION_TAB = "PAGINATION_TAB"

export const SORT_AGAIN_TAB = "SORT_AGAIN_TAB"

export const CHANGE_MAIN_TAB = "CHANGE_MAIN_TAB"

export const SET_UPDATE_ZALO_PAGE = 'SET_UPDATE_ZALO_PAGE'

export const SET_INFORMATION_CALL_SSE = 'INFORMATION_CALL_SSE'

export const resetListRoles = (roles) => {
    return {
        type: RESET_LIST_ROLES,
        payload: roles
    }
}

export const onAddTab = (datas) => {
    return {
        type: ADD_TAB,
        payload: datas
    }
}

export const onAddListTab = (datas) => {
    return {
        type: ADD_LIST_TAB,
        payload: datas
    }
}

export const onRemoveTab = (datas) => {
    return {
        type: REMOVE_TAB,
        payload: datas
    }
}

export const onChangeActiveTab = (datas) => {
    return {
        type: CHANGE_TAB_ACTIVE,
        payload: datas
    }
}

export const onChangeSortAgainTab = (datas) => {
    return {
        type: SORT_AGAIN_TAB,
        payload: datas
    }
}

export const onChangeMainTab = (datas) => {
    return {
        type: CHANGE_MAIN_TAB,
        payload: datas
    }
}

export const fetchListRoles = (roles) => {
    return {
        type: FETCH_LIST_ROLES,
        payload: roles
    }
}
